import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { WhyVerification } from "@/components/WhyVerification";
import { HowItWorks } from "@/components/HowItWorks";
import { VerificationStandards } from "@/components/VerificationStandards";
import { SupplierProfiles } from "@/components/SupplierProfiles";
import { ConnectedWorkspace } from "@/components/ConnectedWorkspace";
import { BusinessOutcomes } from "@/components/BusinessOutcomes";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App" data-testid="verified-manufacturers-landing">
      <Navbar />
      <main>
        <Hero />
        <WhyVerification />
        <HowItWorks />
        <VerificationStandards />
        <SupplierProfiles />
        <ConnectedWorkspace />
        <BusinessOutcomes />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
